// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import { useDomainBundle } from '../modules';

import styles from './Price.scss';

export function BundlePrice(): React.MixedElement {
  const { __, formatPrice } = useTranslator();

  const { price, normalPrice, currency } = useDomainBundle();

  /// TODO: use real duration

  return (
    <Base flex gap="xsmall">
      {/* duration + normal price */}
      <Base>
        <Text>{__('%(count)s year at', { count: 1 })} </Text>
        <Text decoration="line-through">
          {formatPrice(normalPrice, currency)}
        </Text>
      </Base>
      {/* discounted price */}
      <Base weight="semibold" className={styles.discountPrice}>
        {formatPrice(price, currency)}
      </Base>
    </Base>
  );
}
